
import { useLocation, useNavigate } from "react-router-dom";

import { motion, useUnmountEffect } from 'motion/react';
import { useState, useRef, useEffect} from 'react';

import icone_XP from '../../assets/imagens/icone_XP.png';
import DefaultModal from '../../components/Modais/DefaultModal';
import Answers from "../../components/Answers";
import DescricaoProblema from "../../components/ui/DescricaoProblema";
import QuestoesImage from "../../components/QuestoesImage";
import InicialChamado from "../../components/InicialChamado";
import Header from '../../components/Header'

import {API_URL} from '../../config/api'

import './Chamado.css';
export default function Chamado() {
    const audioTimerRef = useRef(null);

    const [correctAnswer, setCorrectAnswer] = useState(null);
    const [scoreRecebido, setScoreRecebido] = useState(null);
    const [tempoAcabou, setTempoAcabou] = useState(false)
    const [animarMoeda, setAnimarMoeda] = useState(false);

    const [destino, setDestino] = useState({
        x: 0,
        y: 0
    });

    const moedaRef = useRef(null);

    const navigate = useNavigate();
    const location = useLocation();

    const { ticket } = location.state || {};

    const token = localStorage.getItem("token")

    //ANIMAÇÃO DA MOEDA
    const handleSeguir = () => {

        const audio = new Audio('/sounds/moeda.mp3')
        audio.play().catch(error => console.log("Não foi possível reproduzir este audio: ", error))

        const moeda = moedaRef.current;

        const caixaXP = document
            .getElementById("xp-box");


        if (!moeda || !caixaXP) {
            return;
        }


        const posicaoMoeda = moeda.getBoundingClientRect();

        const posicaoCaixaXP = caixaXP.getBoundingClientRect();


        const x =
            posicaoCaixaXP.left -
            posicaoMoeda.left;


        const y =
            posicaoCaixaXP.top -
            posicaoMoeda.top;


        setDestino({
            x: x,
            y: y
        });
        setAnimarMoeda(true);

        setTimeout(()=>{
            navigate('/inicial')
        },1000)
       
    };

    //Acabou o tempo
    const handleAvancar = async () => {
        console.log(ticket)
        await fetch(`${API_URL}/user/timeout/${ticket.userTicketId}`,{
            method: "PUT",
            headers: {
                "Authorization": `Bearer ${token}`
            }
        })
            .then(response => {
                if (!response.ok) {
                throw new Error(`Erro: ${response.status}`);
                }
                return response.text(); 
                
            })
            .then(data => {
                console.log(data)
                navigate('/inicial')
            })
            .catch(error => {
                console.error('Erro na requisição:', error.message);
            });
    }

    const emitirSom = (acertou) =>{
        if(acertou === "errado"){
            console.log(correctAnswer)
            const audio = new Audio('/sounds/lowBuzzer.mp3')
            audio.play()
        }else if(acertou === "certo"){
            const audio = new Audio('/sounds/positive.mp3')
            audio.play()
        }
    }

    useEffect(() => {

        const audio = new Audio("/sounds/clockTiming.mp3");

        audio.loop = true;
        audio.volume = 0.2;

        audioTimerRef.current = audio;

        return () => {
            audio.pause();
            audio.currentTime = 0;
        };

    }, []);


    return (
        <>
            <Header />
            <div className={ticket.type === "FORMULARIO"? "containerChamado" : "containerChamadoImage"}>

                <InicialChamado audioTimerRef={audioTimerRef} setTempoAcabou={setTempoAcabou} sla={ticket.sla} userTicketId={ticket.userTicketId} maxScore={ticket.maxScore}/>    

                {/* DESCRIÇÃO DO PROBLEMA */}
                <DescricaoProblema requester={ticket.requester} description={ticket.description} className={ticket.type === "FORMULARIO" ? "formulario" : "imagem"}/>


                {ticket.image && 
                <div className="respostas">
                    <QuestoesImage 
                        image={ticket.image}
                        setCorrectAnswer={setCorrectAnswer}
                        correctAnswer={correctAnswer}
                        scoreRecebido={scoreRecebido}
                        setScoreRecebido={setScoreRecebido}
                        ticketId={ticket.ticketId}
                        emitirSom={emitirSom}
                        />
                </div>}

                {/* FORMULÁRIO */}                   
                {ticket.answers && 
                <div className="respostas">
                    <h3>  Escolha uma opção de resposta: </h3>

                    <Answers 
                        answers={ticket.answers}
                        correctAnswer={correctAnswer}
                        setCorrectAnswer={setCorrectAnswer} 
                        setScoreRecebido={setScoreRecebido}
                        ticketId={ticket.ticketId}
                        emitirSom={emitirSom}
                        />
                </div>}

            </div>

            {/* MODAL RESPOSTA CERTA*/}
            <DefaultModal modalIsOpen={correctAnswer} closeModal={() => handleSeguir() } sound='positive'>

                <h1> Acertou em cheio! </h1>

                <p>  Você Recebeu: </p>


                <div id="scoreRecebido" className="flex">
                    <motion.img
                        ref={moedaRef}
                        src={icone_XP}
                        width={40}
                        height={40}
                        initial={{
                            x: 0,
                            y: 0,
                            opacity: 1,
                            scale: 1
                        }}
                        animate={
                            animarMoeda
                                ? {
                                    x: destino.x,
                                    y: destino.y,
                                    opacity: 0,
                                    scale: 0.5
                                }
                                : {
                                    x: 0,
                                    y: 0,
                                    opacity: 1,
                                    scale: 1
                                }
                        }


                        transition={{
                            duration: 0.8,
                            ease: "easeInOut"
                        }}
                        onAnimationComplete={() => {
                            console.log("Animação terminou: ", animarMoeda)
                           if(animarMoeda){
                            navigate("/inicial")
                           }
                        }}

                    />
                    <p className="numero scoreRecebido">  {scoreRecebido} </p>

                </div>

            </DefaultModal>


            {/* MODAL ACABOU O TEMPO*/}
            <DefaultModal modalIsOpen={tempoAcabou} closeModal={handleAvancar} sound='timeout'>

                <h1> OPS! TEMPO ACABOU </h1>

                <div id="scoreRecebido" className="flex">
                    <img
                        src={icone_XP}
                        width={40}
                        height={40}
                    />   
                    <p className="numero scoreRecebido">  0 </p>

                </div>

            </DefaultModal>

        </>
    );
}